import type { Getter } from "jotai";
import { atom } from "jotai";
import type { IHeaderV2ContentStore } from "./header-v2-content-store";
import { HeaderV2ContentStore } from "./header-v2-content-store";
import type { IHeaderV2LayoutStore } from "./header-v2-layout-store";
import { HeaderV2LayoutStore } from "./header-v2-layout-store";
import type { IHeaderV2ProgressStore } from "./header-v2-progress-store";
import { HeaderV2ProgressStore } from "./header-v2-progress-store";

function getter(get: Getter) {
  const layoutStore = get(HeaderV2LayoutStore);
  const contentStore = get(HeaderV2ContentStore);
  const progressStore = get(HeaderV2ProgressStore);

  return { layoutStore, contentStore, progressStore };
}

export interface IHeaderV2Store {
  layoutStore?: IHeaderV2LayoutStore;
  contentStore?: IHeaderV2ContentStore;
  progressStore?: IHeaderV2ProgressStore;
  isLogoClickable?: boolean;
}

export const HeaderV2Store = atom<IHeaderV2Store>(getter);
